import { Component, OnInit, ViewChild  } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { PageEvent, MatSnackBar } from '@angular/material';
import { SessionService } from '../../../service/session/session.module';
import * as Rx from 'rxjs/Rx';
import { LoadingService } from '../../../directive/loading/loading.module';
import * as moment from 'moment';

@Component({
  selector: 'app-admin-adjustment',
  templateUrl: './admin-adjustment.component.html',
  styleUrls: ['./admin-adjustment.component.css']
})
export class AdminAdjustmentComponent implements OnInit {
  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;
  adjustmentList = []
  productAdjustmentList = [];
  adjustmentMin = {
    system: {
      company: {
        main: {
          uuid: ''
        }
      }
    },
    max: 10,
    offset: 0,
    order: "desc",
    filter: {
      name: '',
      value: ''
    }
  }

  paginatorModel = {
    total: 0,
    pageSizeOptions: [2, 5, 10, 25, 100],
  };

  // MatPaginator Output
  pageEvent: PageEvent;
  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object:{
      main:{
        uuid:''
      }
    }
  }
  constructor(private session: SessionService, public loadingService: LoadingService, public snackBar: MatSnackBar) {

    this.metadata.searchBoxInput.debounceTime(700)
    .switchMap(val => {
      // console.log('called once',val)
      if(val != ''){
        this.adjustmentList = [];
        this.adjustmentMin.filter.name = 'searchElement';
      }else{
        this.adjustmentList = [];
        this.adjustmentMin.filter.name = '';
        this.adjustmentMin.filter.value = '';
        val = 'false'
      }
      this.getAdjustmentList();
      return val;
    }).subscribe(results => {
      // Modificaciones sobre cada letra si se requiere
    }, error => {
    console.log('error logged:');
    this.snackBar.open(error.message, 'Error', {duration: 5000});
    console.log(error);
  });
  }

  ngOnInit() {
    this.getAdjustmentList();
  }

  getAdjustmentList() {
    this.loadingService.wait();
    this.adjustmentList = [];
    this.adjustmentMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.session.getRequest("adjustment:list", this.adjustmentMin).subscribe(
      (data: any) => {
        this.adjustmentList = data.object.instanceList;
        this.paginatorModel.total = data.object.total;
        this.loadingService.hide();
      },
      error => {
        console.log("adjustment:list", error);
        this.loadingService.hide();
      }
    );
  }
  /*
  Funcionalidad para colocar el objeto en el menu de opciones
  */
  objectSelected(object){
    for(let i=0; i < this.adjustmentList.length; i++){
      this.adjustmentList[i].main.selected = false;
    }
    if(object.main.uuid == this.metadata.object.main.uuid){
      object.main.selected = false;
      this.metadata.object.main.uuid = '';
    }else{
      object.main.selected = true;
      this.metadata.object = JSON.parse(JSON.stringify(object));;
    }
  }

  /*
    *Funcion para buscar
  */
  search(){
    this.metadata.searchBoxInput.next(this.adjustmentMin.filter.value);
  }
  // funcion para obtener los datos del paginado.
  onPaginateChange(event){
    this.adjustmentMin.offset = (event.pageIndex * event.pageSize);
    this.adjustmentMin.max = event.pageSize;
    this.getAdjustmentList();
  }

  handleUpdated(event) {
    this.adjustmentMin.offset = (this.pageEvent ? this.pageEvent.pageIndex * this.pageEvent.pageSize  : this.adjustmentMin.offset);
    this.getAdjustmentList();
  }
  //funcion para controlar si se abre o cierra el menu

  toogleMenu(ev){
    this.drawerCtrl.opened = ev;
  }

}
